t = require('views/internal/teacup-with-helpers')('member_billing_org_link')

module.exports = ->
  t.li ->
    t.a { href: t.mustacheVar('billingLink') }, ->
      t.format 'displayname-billing-page', { displayName: t.mustacheVar('displayName') }



// WEBPACK FOOTER //
// ./app/scripts/views/templates/member_billing_org_link.coffee